/// <reference path="../../Scripts/typings/knockout/knockout.d.ts" />
define('models/socialnetwork',["require", "exports"], function (require, exports) {
    "use strict";
    var NetworkMember = (function () {
        function NetworkMember() {
        }
        return NetworkMember;
    }());
    exports.NetworkMember = NetworkMember;
    var Contact = (function () {
        function Contact() {
        }
        return Contact;
    }());
    exports.Contact = Contact;
    var Organization = (function () {
        function Organization() {
        }
        return Organization;
    }());
    exports.Organization = Organization;
});

